// DataTable.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { backend, CHAIN_CONNECTIONS } from '../config';
import UploadKey from './UploadKey';
import CustomizePDF from './CustomizePDF'; // Import the PDF generation component
import '../Styles/DataTable.css';

const DataTable = ({ isAuthenticated }) => {
  const [data, setData] = useState([]);
  const navigate = useNavigate();

  const [uploadedFile, setUploadedFile] = useState(null);

  const handleFileUpload = (file) => {
    setUploadedFile(file);
  };

  useEffect(() => {
    if (isAuthenticated) {
      //
    }
  }, [isAuthenticated]);

  const handleLogout = () => {
    sessionStorage.setItem('isAuthenticated', 'false');
    sessionStorage.removeItem('authToken');
    navigate('/');
  };

  const fetchData = async () => {
    const BUTTON = document.getElementById("refreshData")
    BUTTON.classList.add("disabled");
    BUTTON.setAttribute("disabled", true);
    BUTTON.innerHTML = "Loading..."

    let formData = new FormData();
    formData.append("cipheredKey", uploadedFile);

    try {
      const token = sessionStorage.getItem('authToken');
      const response = await fetch(backend + 'reg/refresh-data', {
        method: "POST",
        headers: {
          'Authorization': token
        },
        body: formData,
      });
      if (response.ok) {
        const dataBackEnd = await response.json();
        console.log("fetchData", dataBackEnd)

        // Sort the data by `insertedIndex`, which is nested in the `source` field of each object
        /*const dataSorted = data.finalized.sort((a, b) => {
          if (a.source && b.source) {
            return a.source.insertedIndex - b.source.insertedIndex;
          }
          // Handle cases where `source` might be missing to avoid runtime errors
          return 0;
        });*/
        setData(dataBackEnd.finalized);
      } else {
        console.error('Error fetching synthetic data');
        handleLogout()
      }
    } catch (error) {
      console.error('Error fetching synthetic data:', error);
      handleLogout()
    }

    BUTTON.classList.remove("disabled");
    BUTTON.removeAttribute("disabled");
    BUTTON.innerHTML = "Refresh"
  };

  const handleExportPDF = () => {
    // Call the PDF generation function from the child component
    // Pass the data state to the child component for PDF generation
    if (data.length > 0) {
      document.getElementById('generate-pdf-button').click();
    } else {
      alert("No data available to export.");
    }
  };

  return (
    <div className="table-container">
      <div className="button-wrapper">
        <UploadKey onFileUpload={handleFileUpload} />
        <button id="refreshData" className="secondary-button refresh-button disabled" onClick={fetchData}>
          Refresh
        </button>
        <button id="export-pdf" className="secondary-button" onClick={handleExportPDF}>
          Export as PDF
        </button>
      </div>
      <table className="data-table">
        <thead>
          <tr>
            <th> N </th>
            <th>Deposit Tx Hash</th>
            <th>Deposit Blockchain</th>
            <th>Deposit Address</th>
            <th>Withdraw Tx Hash</th>
            <th>Withdraw Blockchain</th>
            <th>Relayer Address</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => {
            const getChainDetails = (blockchainId) => {
              const chainId = CHAIN_CONNECTIONS[blockchainId];
              console.log(chainId)
              if (chainId) {
                return chainId;
              }
              return null;
            };

            const sourceDetails = getChainDetails(row.sources[0].blockchainid);
            const targetDetails = getChainDetails(row.targets[0].blockchainid);

            const sourceLink = sourceDetails ? sourceDetails.link : '';
            const sourceAddressLink = sourceDetails ? sourceDetails.linkAddress : '';
            const targetLink = targetDetails ? targetDetails.link : '';
            const targetAddressLink = targetDetails ? targetDetails.linkAddress : '';

            return (
              <tr key={index}>
                <td className="target">{index + 1}</td>
                <td className="source">
                  <a
                    href={sourceLink + row.sources[0].txhash}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-style"
                  >
                    {row.sources[0].txhash.slice(0, 6) + '...' + row.sources[0].txhash.slice(-4)}
                  </a>
                </td>
                <td className="source">{sourceDetails ? sourceDetails.name : ''}</td>
                <td className="source">
                  <a
                    href={sourceAddressLink + row.sources[0].sender}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-style"
                  >
                    {row.sources[0].sender.slice(0, 6) + '...' + row.sources[0].sender.slice(-4)}
                  </a>
                </td>
                <td className="target">
                  <a
                    href={targetLink + row.targets[0].txhash}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-style"
                  >
                    {row.targets[0].txhash.slice(0, 6) + '...' + row.targets[0].txhash.slice(-4)}
                  </a>
                </td>
                <td className="target">{targetDetails ? targetDetails.name : ''}</td>
                <td className="target">
                  <a
                    href={targetAddressLink + row.targets[0].sender}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="link-style"
                  >
                    {row.targets[0].sender.slice(0, 6) + '...' + row.targets[0].sender.slice(-4)}
                  </a>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <CustomizePDF data={data} />
    </div>
  );
};

export default DataTable;